module.exports = __webpack_public_path__ + "static/media/eventPoster.2c7db783.jpeg";